const TRUE = 'true';
const FALSE = 'false';

const parsedSummaryValues = {
  TRUE: 'Yes',
  FALSE: 'No'
};

function getParsedSummaryValue(value) {
  if (value === TRUE) return parsedSummaryValues.TRUE;
  if (value === FALSE) return parsedSummaryValues.FALSE;

  return value;
}

export default getParsedSummaryValue;
